// extracted by mini-css-extract-plugin
export default {"information-wrapper":"Information_information-wrapper__KUZDF","response":"Information_response__lS2Jz"};